export enum OrderItemStatus {
    PENDING = 0, // paid, not delivered
    DELIVERED = 1, // paid, delivered
    CONFIRMED = 2, // paid, delivered, confirmed
    REFUNDED = 3, // paid, refunded
    AWAITING_PAYMENT = 4, // OrderPaymentStatus 0
    PAYMENT_ERROR = 5, // OrderPaymentStatus 4 or 3
    PICKED_UP = 6, // for instore orders
}